<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>
      {{title}}
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <mat-card-content class="no-padding">
      <div>

        <mat-card>
          <mat-card-header class="header-padrao title">
            <mat-card-title>
              <mat-label>Nº Manifesto:</mat-label>
              <mat-label>
                {{numeroCompletoManifesto}}
              </mat-label>

              <mat-label> - Vencimento do SLA:</mat-label>
              <mat-label class="contador">
                {{contador}}
              </mat-label>
            </mat-card-title>
          </mat-card-header>
        </mat-card>


        <mat-card class="filter">
          <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
          <mat-card-content class="apontamento-filtros">
            <div>
              <form class="filtros-header" [formGroup]="form">
                <div class="header-filter-log">
                  <mat-form-field class="flag-width flag-notification">
                    <mat-label>Data Recepção</mat-label>
                    <mat-select formControlName="dataRecepcao">
                      <mat-option selected value="-1">Todos</mat-option>
                      <mat-option value="0">Pendente de recepção</mat-option>
                      <mat-option value="1">Recepcionado</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="flag-width flag-notification">
                    <mat-label>Ressalva</mat-label>
                    <mat-select formControlName="ressalva">
                      <mat-option selected value="-1">Todos</mat-option>
                      <mat-option value="1">Com ressalva</mat-option>
                      <mat-option value="0">Sem ressalva</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Código de Barras</mat-label>
                    <input matInput autocomplete="off" formControlName="codigoBarras">
                  </mat-form-field>

                  <button mat-icon-button class="notification-button cursor-pointer-icon" (click)="clearFields()"
                    matTooltip="Limpar Campos">
                    <mat-icon fontSet="fas" fontIcon="fa-eraser"></mat-icon>
                  </button>

                  <button mat-icon-button class="notification-button cursor-pointer-icon" (click)="search()"
                    matTooltip="Pesquisar">
                    <mat-icon fontSet="fas" fontIcon="fa-search"></mat-icon>
                  </button>

                  <div class="notification-action row">
                    <!-- <button [disabled]="contador=='0:00:00' || contador=='00:00:00' || ((isRessalvaPorVolume === true && pedidoEtiquetas.length==0) || (isRessalvaPorVolume !== true && pedidoIds.length==0))" -->
                      <!-- <button
                      mat-flat-button color="primary" (click)="openModalMERessalva()" class="mr-2">
                      Ressalva
                    </button> -->
                    <button [disabled]="contador=='0:00:00' || contador=='00:00:00' || perfilAcessoTipo === 1 || perfilAcessoTipo === 3  || ((isRessalvaPorVolume === true  && pedidoEtiquetas.length==0) || (isRessalvaPorVolume !== true && pedidoIds.length==0) ||(isRessalvaPorVolume !== true && pedidoIds.length==0))"
                      mat-flat-button color="primary" (click)="openModalMERessalva()" class="mr-2">
                      Ressalva
                    </button>
                    <!-- <button
                      mat-flat-button color="primary" (click)="openModalMERessalva()" class="mr-2">
                      Ressalva
                    </button> -->
                    <button mat-flat-button color="primary" (click)="voltar()">
                      Voltar
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div id="scrollable-table">
              <table #table id="communication-table" mat-table [dataSource]="collection" multiTemplateDataRows>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef class="text-center" class="checkbox" scope="col">
                    <mat-checkbox color="primary" #allCheckbox
                      *ngIf="collection && collection.data && collection.data.length"
                      (change)="selectAll($event.checked)" 
                      [checked]="allSelected" 
                      [indeterminate]="someSelected"
                      [disabled]="true">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center" class="checkbox">
                    <!-- <mat-checkbox color="primary" *ngIf="collection && collection.data && collection.data.length"
                          (change)="select(item, $event.checked)" [checked]="item.selected"> -->
                    <mat-checkbox color="primary" *ngIf="!(item.rat && item.rat > 0) && item.flgEmRota ===false && isShowCheckOnPedido"
                      (change)="select(item, $event.checked)" [checked]="item.selected">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="cliente">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    Cliente
                  </th>
                  <td mat-cell *matCellDef="let row" class="text-center">
                    {{ row.cliente }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="segmento">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    Segmento
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.segmento }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="NRT">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    NRT
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.nrt }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="volumes">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    Volume
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.volume }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="documento">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    Documento
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.documento }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="destinatario">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    Destinatário
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.destinatario }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="cidade">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    Cidade
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.cidade }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="UF">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    UF
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.uf }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="dtRecepcao">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    Data Recepção
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item?.dtRecepcao | date: 'dd/MM/yyyy' }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="RAT">
                  <th mat-header-cell *matHeaderCellDef class="text-center">
                    RAT
                  </th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    {{ item.rat }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="expandedDetail" *ngIf="isRessalvaPorVolume === true">
                  <td mat-cell class="no-padding" *matCellDef="let row"
                    [attr.colspan]="displayedColumnsSubTable?.length">
                    <div class="element-detail" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">

                      <div class="subCollection row scrollable-table">
                        <mat-label>Volumes do Manifesto</mat-label>
                        <table #table id="subTableCollection"  mat-table
                          [dataSource]="row.pedidoVolumeDetalhamento">
                          <ng-container matColumnDef="checkbox">
                            <th mat-header-cell *matHeaderCellDef>
                              <mat-checkbox color="primary" #allCheckboxItem
                              (change)="selectAllItem($event.checked, row)" 
                              [checked]="row.selected" 
                              [indeterminate]="row.someSelected"
                              [disabled]="true">
                            </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let item">
                              <mat-checkbox *ngIf="row.flgEmRota ===false && item.temRessalva !=='Sim'"
                              (change)="selectItem(row, item, $event.checked)" [checked]="item.selected" ></mat-checkbox>
                              <!-- <mat-checkbox *ngIf="row.flgEmRota ===false && item.temRessalva !=='Sim'"
                                (change)="changePedidosIds(row.nrt, item, $event.checked)"></mat-checkbox> -->
                            </td>
                            <td mat-footer-cell *matFooterCellDef></td>
                          </ng-container>


                          <ng-container matColumnDef="ressalva">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Ressalva
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.temRessalva }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="idVolume">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Id Volume
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.volumeId }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="etiqueta">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Etiqueta
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.etiqueta }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="etiqueta2">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Etiqueta 2
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.etiqueta2 }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="altura">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Altura
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.altura }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="comprimento">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Comprimento
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.comprimento }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="largura">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Largura
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.largura }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="peso">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Peso
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.peso }}
                            </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumnsSubTable"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsSubTable;"></tr>
                        </table>

                        <div *ngIf="!isLoading && row.pedidoVolumeDetalhamento?.data?.length === 0"
                          class="d-flex justify-content-center align-items-center" style="height: 100px;">
                          Nenhum registro foi encontrado!
                        </div>
                      </div>

                      <div class="subCollection2 row scrollable-table">
                        <mat-label>Volumes Fora do Manifesto</mat-label>
                        <table #table id="subTableCollection2" mat-table
                          [dataSource]="row.pedidoVolumeDetalhamentoOutroManifesto">

                          <ng-container matColumnDef="mt">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              MT
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.manifestoId }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="idVolume">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Id Volume
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.volumeId }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="etiqueta">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Etiqueta
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.etiqueta }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="etiqueta2">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Etiqueta 2
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.etiqueta2 }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="altura">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Altura
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.altura }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="comprimento">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Comprimento
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.comprimento }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="largura">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Largura
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.largura }}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="peso">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                              Peso
                            </th>
                            <td mat-cell *matCellDef="let row" class="text-center">
                              {{ row.peso }}
                            </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumnsSubTable2"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsSubTable2;"></tr>
                        </table>

                        <div *ngIf="!isLoading && row.pedidoVolumeDetalhamentoOutroManifesto?.data?.length === 0"
                          class="d-flex justify-content-center align-items-center" style="height: 100px;">
                          Nenhum registro foi encontrado!
                        </div>

                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"
                  [class.expanded-row]="expandedElement === row"
                  (click)="expandedElement = expandedElement === row ? null : row;">
                </tr>
                <ng-container *ngIf="isRessalvaPorVolume === true">
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
                </ng-container>

              </table>
              <div *ngIf="!isLoading && collection?.data?.length === 0"
                class="d-flex justify-content-center align-items-center" style="height: 100px">
                Nenhum registro foi encontrado!
              </div>

            </div>
            <div>
              <app-paginacao [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
                (page)="onPageChange($event)" [pageSizeOptions]="[5, 10,50, 100]">
              </app-paginacao>
            </div>

          </mat-card-content>
          <div></div>
        </mat-card>


      </div>
    </mat-card-content>
    <div>
    </div>
  </div>
</div>
